<template>
    <div style="width: 100%; margin: 0 auto; background: #f5f5f5; margin-top: 0.7rem;position: relative;" class="ccc">
        <div class="container"
            :style="{ '--background': (backgroundImage.indexOf('http') > -1 || backgroundImage.indexOf('https') > -1 ? 'url(' + backgroundImage + ')' : backgroundImage) }">
            <div class="title">{{ title }}</div>
            <div ref="previewRef" :style="{ height: previeHeight + 'px' }" class="preview" v-html="content">

            </div>
            <div style="text-align: center;margin: 20px auto;" v-if="!isOver() && activityType != 5 && activityType != 6">
                <el-button v-if="activityType == 2 && uploadType != 2 || activityType != 2" size="large" type="primary"
                    style="min-width: 280px;font-size:16px;height:45px;" @click="joinActive">{{
                        joinText
                    }}</el-button>
                <el-button size="large" type="primary" style="min-width: 280px;font-size:16px;height:45px;" @click="allTo"
                    v-if="activityType == 2">查看我的作品</el-button>

            </div>
            <div style="text-align: center;margin: 20px auto;" v-if="activityType == 4 && viewSwitch == 1">
                <el-button size="large" type="primary" style="min-width: 280px;font-size:16px;height:45px;"
                    @click="allTo">查看全部作品</el-button>
            </div>
        </div>
        <div v-if="!isOver()" class="tip">
            <span>倒计时</span>
            <span style="font-size: 19px;">{{ getDay() }}</span>
            <span>DAYS</span>
        </div>
        <div class="share" @click.stop="handleShare">
            <el-icon style="width: 20px;height: 20px;"><svg style="width: 20px;height: 20px;" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M928 480c-17.664 0-32 14.336-32 32l0 320c0 17.664-14.336 32-32 32L160 864c-17.664 0-32-14.336-32-32L128 288c0-17.664 14.336-32 32-32l224 0 0 0c0 0 0 0 0 0 17.664 0 32-14.336 32-32s-14.336-32-32-32c-1.024 0-1.888 0.48-2.88 0.576L160.384 192.576c-52.96 0-95.904 43.008-95.904 96.064l0 543.872c0 53.056 42.944 96.064 95.904 96.064l704.224 0c52.96 0 95.904-43.008 95.904-96.064L960.512 512 960 512C960 494.336 945.664 480 928 480zM402.688 620.768c-1.92 4.128-3.168 8.608-3.168 13.44 0 17.664 14.336 32 32 32 15.456 0 27.744-11.168 30.752-25.76l0.64 0c37.12-189.696 193.984-336.256 388.672-358.272l-67.776 67.776c-12.512 12.512-12.512 32.768 0 45.248 12.512 12.512 32.768 12.512 45.248 0l122.528-122.528c12.512-12.512 12.512-32.768 0-45.248l-122.528-122.528c-12.512-12.512-32.768-12.512-45.248 0-12.512 12.512-12.512 32.768 0 45.248l67.52 67.52C628.256 239.872 448.224 405.408 402.688 620.768z">
                    </path>
                </svg></el-icon>
            <span>分 享</span>
        </div>
        <el-dialog v-model="isShowShare" :show-close="true" :close-on-click-modal="false" title="分享" width="500">
            <div v-if="!route.query.t" class=""
                style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
                <div class="">
                    <canvas ref="qrcodeCanvas"></canvas>
                </div>
                <div class="" style=" color: #333333; font-size: 14px;">
                    扫描二维码，参与内容
                </div>

            </div>
            <div style="margin-top: 16px;">
                <div style=" color: #333333; font-size: 14px;">
                    <span>分享活动链接</span>
                </div>
                <div
                    style="border: 1px solid  #E5E6EB;border-radius: 8px;height: 45px;width: 100%;line-height: 45px;text-align: left;margin-top: 8px;color: #000000;padding-left: 12px;">
                    <span
                        style="display: inline-block; white-space: nowrap;overflow: hidden; text-overflow: ellipsis; width: 454px;">{{
                            fxxx }}</span>
                </div>
            </div>
            <div @click="copyBtn"
                style="background:#2978FF;border-radius: 12px;height: 45px;width: 100%;text-align: center;line-height: 45px;color: #FFF;margin-top: 8px;cursor: pointer;">
                <span>复制链接</span>
            </div>
        </el-dialog>
        <!-- <div class="qrcode" v-show="isShowShare">
            <div class="qrcode-box">
                <canvas ref="qrcodeCanvas"></canvas>
            </div>
            <div class="qrcode-text">
                扫描二维码，参与活动
            </div>

        </div> -->
    </div>
</template>
<script lang="ts" setup>
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import QRCode from 'qrcode'
import useClipboard from 'vue-clipboard3'
const route = useRoute();
import { ref, onBeforeMount, onMounted, nextTick, watch } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { error } from "console";
import getsignatureInfo from "../../wx/index.js";
import img____ from "../../assets/fx.png"
const router = useRouter();
const joinText = ref('立即报名')
const content = ref('')
const title = ref('')
const qrcodeCanvas = ref<any>(null)
const backgroundImage = ref('')
const previeHeight = ref(0)
const id = ref<number | undefined | string>(0)
const previewRef = ref<any>()
const stopTime = ref()
const startTime = ref()
const isShowShare = ref(false)
const isJoin = ref(0)
const { toClipboard } = useClipboard()
const activityType: any = ref(0);
const uploadType = ref('');
const viewSwitch = ref(2);
const getInfo = function () {
    Axios("get", "/system/activity/" + id.value, null, false, function (res: any) {
        if (res.data.code == 200) {
            activityType.value = res.data.data.activityType
            title.value = res.data.data.title
            content.value = res.data.data.noticeContent || ''
            backgroundImage.value = res.data.data.backgroundImage
            stopTime.value = res.data.data.stopTime
            startTime.value = res.data.data.startTime
            isJoin.value = res.data.data.isJoin
            uploadType.value = res.data.data.uploadType
            res.data.data.activityType == 4 && (viewSwitch.value = res.data.data.viewSwitch)
            getsignatureInfo({
                url: encodeURIComponent(location.href.split('#')[0]),
                title: res.data.data.title,
                desc: res.data.data.introduction,
                imgUrl: res.data.data.shareImage || img____
            })
            if (isJoin.value == 1 || isJoin.value == 2) {
                joinText.value = activityType.value == 2 ? isJoin.value == 1 ? '立即报名' : '上传作品' : '立即参与活动'
            } else {
                joinText.value = '立即报名'
            }
        } else {
            ElMessage.error(res.data.message);
        }
    });
};
const allTo = () => {
    router.push({
        path: '/allProduction', query: {
            id: id.value
        }
    })
}
const fxxx = ref(location.href);
const copyBtn = async () => {
    await toClipboard(location.href);
    ElMessage.success("复制成功");
    isShowShare.value = false
}
const getQrCode = function () {
    let opts = {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 1,
        margin: 2,
        width: 200,
        height: 200,
        text: route.fullPath,
        color: {
            light: '#fff'
        }
    }
    QRCode.toCanvas(qrcodeCanvas.value, location.href, opts, function (error: any) { if (error) console.info(error) });
}
const getDay = function () {
    const endTime = new Date(stopTime.value)
    const now = new Date()
    return Math.ceil(((endTime.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));
}
const isOver = function () {
    const endTime = new Date(stopTime.value)
    const beginTime = new Date(startTime.value)
    const now = new Date()
    if ((route.query as any).activityType == 4) {
        return true
    }
    if (endTime.getTime() < now.getTime()) {
        return true;
    } else if (beginTime.getTime() > now.getTime()) {
        return true;
    }
    return false
}
const handleShare = function () {
    isShowShare.value = !isShowShare.value
    nextTick(() => {
        if (!route.query.t) {
            getQrCode()
            if (!!qrcodeCanvas.value) {
                let ctx = qrcodeCanvas.value.getContext('2d')
                let image = new Image()
                image.crossOrigin = 'Anonymous'
                image.src = 'qrcodelogo.png'
                image.onload = () => {
                    ctx.drawImage(image, 75, 75, 50, 50)
                }
            }
        }

    })
}
watch(() => content.value, () => {
    nextTick(() => {
        document.querySelectorAll('p').forEach(function (parent) {
            let img = parent.querySelectorAll('img')
            if (img.length) {
                parent.classList.add('has-img');
                for (let i = 0, item; item = img[i]; i++) {
                    item.addEventListener("click", function (e) {
                        var href = this.getAttribute('data-href')
                        if (href)
                            if (href.indexOf('http') > -1 || href.indexOf('https') > -1) {
                                window.open(href, '_target')
                            }
                    })
                    if (!!item.getAttribute('data-alt') && item.getAttribute('data-alt') != 'null') {
                        var div = document.createElement("div");
                        div.style.position = "absolute";
                        div.style.left = item.offsetLeft + 'px';
                        div.classList.add("image-title")
                        div.style.width = item.clientWidth + 'px'
                        div.style.top = (item.offsetTop + item.clientHeight - 40) + 'px';
                        div.innerText = item.getAttribute('data-alt') as string;
                        parent.append(div);
                    }
                }


            }
        })
        previeHeight.value = previewRef.value.scrollHeight
    })
})
const queryData: any = ref({});
onBeforeMount(() => {
    id.value = route.query.id?.toString()
    if (route.query.t) {
        const data = JSON.parse(decodeURIComponent(route.query.t as string))
        queryData.value = data;
        activityType.value = data.activityType
        title.value = data.title
        try {
            content.value = decodeURIComponent(data.noticeContent) || ''
        } catch (e) {
            content.value = data.noticeContent || ""
        }
        backgroundImage.value = data.backgroundImage || ''
        stopTime.value = data.stopTime
        //  data.stopTime
        startTime.value = data.startTime
        isJoin.value = data.isJoin
        if (isJoin.value == 1 || isJoin.value == 2) {
            joinText.value = activityType.value == 2 ? isJoin.value == 1 ? '立即报名' : '上传作品' : '立即参与活动'
        } else {
            joinText.value = route.query.t ? "立即上传" : '立即报名'
        }
    } else {
        getInfo()
    }

})
onMounted(async () => {
    await nextTick();

})
const joinActive = () => {
    if (localStorage.getItem("token") == null) {
        router.push({
            path: "/TgLogin",
        });
        return
    }
    if (activityType.value == 2 && isJoin.value == 0) {
        const saveForm = {
            activityId: id.value
        }
        Axios("post", "/system/activity-join", Object.keys(queryData.value).length ? {
            taskId: queryData.value.id,
            activityId: queryData.value.activityId,
        } : saveForm, false, function (res) {
            if (res.data.code == 200) {
                router.push({
                    path: "/JoinActivity",
                    query: Object.keys(queryData.value).length ? {
                        id: queryData.value.id,
                        activityType: queryData.value.activityType,
                        activityId: queryData.value.activityId,
                    } : { id: id.value, activityType: activityType.value }
                });
            }
        })
        return
    } else if (activityType.value == 2 && isJoin.value == 1) {
        router.push({
            path: "/JoinActivity",
            query: Object.keys(queryData.value).length ? {
                id: queryData.value.id,
                activityType: queryData.value.activityType,
                activityId: queryData.value.activityId,
            } : { id: id.value, activityType: activityType.value }
        });
        return
    } else if (activityType.value == 2 && isJoin.value == 2) {
        router.push({
            path: "/AddMaterial",
            query: Object.keys(queryData.value).length ? {
                id: queryData.value.id,
                activityType: queryData.value.activityType,
                activityId: queryData.value.activityId,
            } : { id: id.value, activityType: activityType.value }
        });
        return
    } else {

    }
    Axios("get", `/member/login-info`, {}, false, (res) => {
        let data = res.data.data;
        data.realStatusName =
            data.realStatus == 0
                ? "待认证"
                : data.realStatus == 1
                    ? "审核中"
                    : data.realStatus == 2
                        ? "认证成功"
                        : "认证失败";
        data.userrealStatusColor == 0
            ? "#ff8c"
            : data.realStatus == 1
                ? "#4169"
                : data.realStatus == 2
                    ? "#00cc33"
                    : "red";
        if (data.realStatus == 0) {
            ElMessageBox.confirm(
                '您还未进行实名认证，请先实名认证',
                '',
                {
                    confirmButtonText: '前往认证',
                    cancelButtonText: '取消',
                    type: 'error',
                    customClass: 'ShowActivity',
                    center: true,
                }
            )
                .then(() => {
                    router.push({
                        path: "/AuthenTication",
                        query: { num: 3 }
                    });
                }).catch(() => {

                })
            return
        } else if (data.realStatus == 1) {
            ElMessage.error("认证状态：审核中");
            return
        } else if (data.realStatus == 2) {
            const saveForm = {
                activityId: id.value
            }

            if (isJoin.value == 0) {
                Axios("post", "/system/activity-join", Object.keys(queryData.value).length ? {
                    taskId: queryData.value.id,
                    activityId: queryData.value.activityId,
                } : saveForm, false, function (res) {
                    if (res.data.code == 200) {

                        ElMessageBox.confirm(
                            '恭喜你报名成功！',
                            '',
                            {
                                confirmButtonText: '参与活动',
                                cancelButtonText: '稍后参与',
                                type: 'success',
                                customClass: 'ShowActivity',
                                center: true,
                            }
                        )
                            .then(() => {
                                router.push({
                                    path: "/JoinActivity",
                                    query: Object.keys(queryData.value).length ? {
                                        id: queryData.value.id,
                                        activityType: queryData.value.activityType,
                                        activityId: queryData.value.activityId,
                                    } : { id: id.value, activityType: activityType.value }
                                });
                            })
                            .catch(() => {
                                joinText.value = '立即参与活动'
                            })
                    }
                })
            } else if (isJoin.value == 1) {
                router.push({
                    path: "/JoinActivity",
                    query: Object.keys(queryData.value).length ? {
                        id: queryData.value.id,
                        activityType: queryData.value.activityType,
                        activityId: queryData.value.activityId,
                    } : { id: id.value, activityType: activityType.value }
                });
            } else if (isJoin.value == 2) {
                router.push({
                    path: "/AddMaterial",
                    query: Object.keys(queryData.value).length ? {
                        id: queryData.value.id,
                        activityType: queryData.value.activityType,
                        activityId: queryData.value.activityId,
                    } : { id: id.value, activityType: activityType.value }
                });
            }
        } else {
            ElMessage.error("认证状态：认证失败");
            return
        }
    });
    return

}
</script>
<style lang="less" scoped>
.ccc {
    width: 800px !important;
    margin: 0 auto !important;
    padding-top: 98px;
    margin-bottom: 32px !important;
}

.tip {
    position: fixed;
    left: 10px;
    top: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ff8a43;
    background: #ffdfcc;
    font-weight: 700;
    padding: 10px;
    line-height: 24px;
    border-radius: 5px;
    z-index: 999999;
}

.share {
    position: fixed;
    left: 10px;
    top: calc(30% + 100px);
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #676869;
    background: #e3e6ec;
    font-weight: 700;
    padding: 10px 14px;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
    z-index: 999999;
    user-select: none;
}

.qrcode {
    position: fixed;
    left: 80px;
    top: calc(30% + 100px);
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #000;
    background: #fff;
    font-weight: 700;
    padding: 30px;
    line-height: 24px;
    border-radius: 10px;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    z-index: 999999;

    .qrcode-box {
        border: 1px solid #e3e6ec;
        border-radius: 10px;
        padding: 2px;
    }
}

.container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    // padding-top: 0.4rem;
    border-radius: 12px;
    background: var(--background);
    background-size: 100% 100%;
    padding: 40px;


    .title {
        text-align: left;
        font-size: 17px;
        font-weight: 700;
        position: relative;
        color: #000;
        z-index: 99;
    }

    .preview {
        position: relative;
        line-height: 1.5;
        padding-bottom: 20px;
        // min-height: calc(100vh - 60px);
        height: auto !important;
        text-align: left;
        width: 100%;

        /deep/ table {
            border-collapse: collapse;

            th {
                background-color: #f5f2f0;
                font-weight: 700;
                text-align: center;
            }

            td,
            th {
                border: 1px solid #ccc;
                line-height: 1.5;
                min-width: 30px;
                padding: 3px 5px;
                text-align: left;
            }

            td {
                height: 24px;
            }
        }

        /deep/ a {
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
            -webkit-user-select: none;
            -moz-user-focus: none;
            -moz-user-select: none;
            color: #409eff;
        }

        /deep/ p,
        /deep/ div {
            position: relative;
            z-index: 2;
        }

        /deep/ hr {
            border-color: #ccc;
            display: block;
            height: 1px;
            margin: 20px auto;
        }

        /deep/ p {
            margin: 15px 0;
            // margin-bottom: 15px;
        }

        /deep/ p:has(img) {
            position: initial;
        }

        /deep/ p.has-img {
            position: initial;
            margin: 0px !important;

            img {
                width: 100% !important;
            }

            .image-title {
                padding: 0.12rem 0.16rem;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
                border-radius: 0.12rem;
                transition: bottom 0.5s;
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                color: #fff;
            }
        }

        /deep/video {
            width: 100% !important;
            object-fit: scale-down !important;
        }

        /deep/audio {
            width: 100% !important;
        }

        /deep/ [data-w-e-type='video'],
        /deep/ [data-w-e-type='audio'] {
            text-align: center;
            width: 100% !important;
        }

        /deep/ [data-visibility='1'] {
            display: none;
        }

        /deep/ [data-position='0'] {
            z-index: 2;
        }

        /deep/ [data-position='1'] {
            z-index: 3;
        }

        /deep/ [data-position='2'] {
            z-index: 1;

            img {
                z-index: 0;
            }
        }

        /deep/ blockquote {
            background-color: #f5f2f0;
            border-left: 8px solid #B4D5FF;
            display: block;
            font-size: 100%;
            line-height: 1.5;
            margin: 10px 0;
            padding: 10px;
        }
    }
}

/deep/.image-title {
    display: none !important;
}
</style>

<style lang="less">
.ShowActivity .el-message-box__title {
    font-size: 60px !important;
    padding-left: 25px !important;
}

.ShowActivity {
    border-radius: 12px !important;
}

.ShowActivity .el-message-box__btns {
    button {
        width: 88px !important;
        line-height: 32px !important;
        text-align: center;
        line-height: 32px;
    }
}
</style>
